import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EventsService } from '../../events.service';
import { GlobalService } from '../../../global.service';
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-spring-break',
  templateUrl: './spring-break.component.html',
  styleUrls: ['./spring-break.component.css']
})
export class SpringBreakComponent implements OnInit {


  public config: PerfectScrollbarConfigInterface = {
    // suppressScrollX:true
  };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;


  mobileView: boolean = false;

  constructor(private router: Router, private activeRoute: ActivatedRoute, public eventService: EventsService,
              public globalService: GlobalService, private titleService:Title) {
    this.titleService.setTitle('Spring Break')
    if (globalService.isBrwoser) {
      if (window.screen.width < 768) {
        this.mobileView = true;
      }
    }
  }

  ngOnInit() {
    this.eventService.insomniaGame = this.router.url.split('/')[2];

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.eventService.insomniaGame = event.url.split('/')[2];
      }
    });

  }


}



